import { render, staticRenderFns } from "./Spoiler.vue?vue&type=template&id=5c60dd6e&scoped=true"
import script from "./Spoiler.vue?vue&type=script&lang=js"
export * from "./Spoiler.vue?vue&type=script&lang=js"
import style0 from "./Spoiler.vue?vue&type=style&index=0&id=5c60dd6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60dd6e",
  null
  
)

export default component.exports